
<template>
  <div v-if="getConfig && getConfig.startStop &&   getJob($route.params.id) && initialized">
    <div class="row">
      <div class="col-sm-12 col-md-8">
        <portlet
                :icon="'fad fa-list'"
                :title=" $t('jobs.detail.comment.title') +' ' +  $t('ui.for')  + ' ' +getJob($route.params.id).uid "
                :actions-block="true"
                :fullheight="true"
                class="portlet-pt-20"
        >
          <template slot="actionsBlock">

            <button class='btn btn-secondary  '
                    @click="$router.go(-1)">
              <i class="fas fa-long-arrow-left mr-2"></i>
              {{$t('ui.back')}}
            </button>
            <div class="mr-5" v-show="getSelectedWorkflow" @click="handleStartStopClick($event, getJobWithWorkflowStates($route.params.id))"
                 v-html="getStartStopButton($route.params.id)"/>
          </template>
          <template slot="portletBody">
            <PerformanceLog :job="getJob($route.params.id)" />
          </template>

        </portlet>
      </div>
      <div class="col-sm-12 col-md-4">
        <portlet
                :icon="'fad fa-list'"
                :title="$t('jobs.detail.title',[getJob($route.params.id).uid])"
                :actions-block="true"
                :fullheight="true"
                class="portlet-pt-20"
        >
          <template slot="actionsBlock">

          </template>
          <template slot="portletBody">
            <JobDetail :job="getJob($route.params.id)"/>
          </template>

        </portlet>
      </div>

      <template v-if="getPages.instructions">
        <div class="col-12">
          <InstructionsViewer :jobId="$route.params.id"></InstructionsViewer>
        </div>
      </template>

      <div class="col-12">
        <portlet
                :icon="'fad fa-list'"
                :title="$t('jobs.detail.productionRunTitle',[getJob($route.params.id).uid])"
                :actions-block="true"
                :fullheight="true"
                class="portlet-pt-20 "
        >
          <template slot="actionsBlock">
            <div v-show="getSelectedWorkflow" @click="handleStartStopClick($event, getJobWithWorkflowStates($route.params.id))"
                 v-html="getStartStopButton($route.params.id)"/>
          </template>
          <template slot="portletBody">
            <JobActivityHistory :job="getJob($route.params.id)"/>
          </template>

        </portlet>
      </div>
      <div class="col-12"  v-if="getConfig.downTime && getConfig.downTime.enabled" >

        <portlet
                :icon="'fad fa-list'"
                :title="$t('downTimes.detailTitle',[getJob($route.params.id).uid])"
                :actions-block="true"
                :fullheight="true"
                class="portlet-pt-20 "
        >

          <template slot="portletBody">
            <JobDownTimes :job="getJob($route.params.id)"/>
          </template>

        </portlet>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import {dataTables} from '../../mixins/dataTables';
import {swalJobs} from '../../mixins/swalJobs';

import JobDetail from '../../components/jobs/JobDetail';
import PerformanceLog from '../../components/jobs/PerformanceLog';
import JobActivityHistory from '../../components/jobs/JobActivityHistory';
import JobDownTimes from '../../components/jobs/JobDownTimes';
//job mixins
import jobMethods from '../../mixins/jobs/jobMethods';
import InstructionsViewer from "@/components/instructions/InstructionsViewer";
import jobScanner from "@/mixins/jobs/jobScanner";
// @vuese
  // @group Job
  // This view  represents the job details from specific job.
  export default {
    name: 'JobsDetails',
    mixins: [dataTables, swalJobs, jobMethods,jobScanner],
    components: {
      InstructionsViewer,
      PerformanceLog,
      JobDetail,
      JobActivityHistory,
      JobDownTimes
    },
    props: {},
    data() {
      return {
        initialized:false,
        time: moment(),
        loaded: false
      };
    },
    computed: {
      ...mapGetters('company', [
        'getConfig', 'getPages'
      ]),
      ...mapGetters('workflows', [
        'getWorkflows',
        'getWorkflowName',
        'getWorkflowsIdName',
        'getWorkflowMultiJobPossible'
      ]),
      ...mapGetters('jobs', [
        'getJobs',
        'getJob',
        'getJobWorkflows',
        'getJobWithWorkflowStates',
        'getJobsWithWorkflowstates',
        'geJobWorkflowStates',
        'getJobActivities',
        'getStartStopButton'
      ]),
      ...mapGetters('productionRuns', [
        'getProductionRunsOfWorkflow',
        'getProducedAmountOfJobId',
        'getProductivityProgressBar'
      ]), ...mapGetters('downTimes', [
        'getDownTimesForJob',
        'getFormattedDownTimeIndicator'
      ]),
      ...mapGetters('users', [
        'getSelectedWorkflow',
        'getMe',
        'getClaims',
        'getRunningJob',
        'getSelectedWorkflowLength'
      ])
    },
    methods: {
      ...mapMutations('users', [
        'setJobWorkflowProduct',
        'setJobRunning',
        'selectedWorkflow'
      ]),
      async handleStartStopClick(event, job) {
        if (event.target.classList.contains('delete') || event.target.closest('.delete')) {
          await this.deleteJob(job);
          if (!this.getJob(this.$route.params.id)) {
            this.$router.push('/start-stop');
          }
        } else {
          this.startStopWorkflow(job);
        }
      },

      fromDateSelected(date) {
        this.customFilters[0].options.range.min = moment(date).utc().startOf('day').toDate();
        localStorage.setItem('start-stop-filter-state', JSON.stringify(this.customFilters));

      },
      //@vuese
      // Gets disabled dates To
      toDateSelected(date) {
        this.customFilters[0].options.range.max = moment(date).utc().endOf('day').toDate();
        localStorage.setItem('start-stop-filter-state', JSON.stringify(this.customFilters));

      },
      dateDisplay(date) {
        return moment(date).utc().format('DD/MM/YY');
      },
      // @vuese
      // Sets up the columns for datatables package from https://git.motivate.nl/js-awesome/motivate-framework-components/blob/v2/src/components/DataTable.vue
      getColumns() {
        let self = this;
        let standardColumns = [
          {
            data: null,
            name: self.$t('jobs.table.amount'),
            visible: self.getConfig.startStop.productivity == 'amount',
            render(data) {
              return data.amount ? data.amount : '';
            }
          },
          {
            data: null,
            name: self.$t('jobs.table.produced'),
            visible: self.getConfig.startStop.productivity == 'amount',
            searchable: false,
            render(data) {
              return self.getProducedAmountOfJobId(data.id);
            }
          }
          // {
          //   data: 'activity',
          //   name: self.$t('jobs.table.activity')
          // }
        ];
        if(self.getConfig.startStop.tableConfig && self.getConfig.startStop.tableConfig.length) {
          let customColumns = self.getConfig.startStop.tableConfig;
          _.each(customColumns, (customColumn) => {
            standardColumns.push(self.generateCustomColumn(customColumn));
          });
        }
        let statusAndButtonColumns = [
          {
            data: null,
            name: self.$t('jobs.table.workflow'),
            width: '10%',
            responsivePriority: 1,
            render(data) {
              let runningWorkflows = data.workflowStates.filter(workflow => workflow.status == 'running');
              return runningWorkflows.map(runningWorkflow => {
                if(runningWorkflow.id == self.getSelectedWorkflow) {
                  return '<b>' + runningWorkflow.name + '</b>';
                } else {
                  return runningWorkflow.name;
                }
              }).join(', ');
            }
          },
          {
            data: null,
            name: self.$t('jobs.table.status'),
            searchable: false,
            orderable: false,
            width: '20%',
            responsivePriority: 1,
            render(data) {
              return self.getProductivityProgressBar(data, self.getConfig);
            }
          },
          {
            data: null,
            name: null,
            searchable: false,
            orderable: false,
            width: '5%',
            responsivePriority: 1,
            render(data) {
              if(data.status === 'finished' || self.getProducedAmountOfJobId(data.id) >= data.amount || !self.getSelectedWorkflow) {
                return '';
              } else if(data.status === 'running') {
                return '<button class="btn btn-danger get-data"><i class="fas fa-stop  get-data"></i> ' + self.$t('jobs.table.stop') + '</button>';
              } else {
                return '<button class="btn btn-primary get-data"><i class="fad fa-play  get-data"></i>' + self.$t('jobs.table.start') + '</button>';
              }
            }
          }
          // {data: 'plannedDate', visible: false} // Still need to check if this actually does anything ?
        ];
        // this.renderComponent();
        return standardColumns.concat(statusAndButtonColumns);
      },

      /**
       * @vuese
       * Show a modal that will force user  to stop the previous job first
       * @arg `jobRunning` the job that's currently running
       * @arg `job` the job that is clicked to start
       * @arg `jobProduct` (if any) product
       */
      showStopOtherJobFirstModal(jobRunning, job, jobProduct) {
        return new Promise((resolve) => {
          this.swalJobAlreadyRunning(jobRunning, job, jobProduct).then(result => {

            if(result.value) {
              let activeJob = this.getJob(jobRunning.jobId) ?this.getJob(jobRunning.jobId) : jobRunning ;
              this.swalJobIsDoneCheck(activeJob.uid, activeJob).then(async res => {
                let jobStatus = '';
                if(res.dismiss == 'backdrop') {
                  return;
                }
                if(res.value) {
                  jobStatus = 'finished';
                }
                if(activeJob.id === activeJob.id) {
                  // this.setUserOrderData(null);
                  this.getOrderWorkflowProduct = null;
                }
                this.setJobStopped(activeJob, jobStatus, new Date(), jobRunning.id).then((res) => {
                  resolve();
                });
              });
              // this.swalAmountProduced(jobRunnning, jobProduct).then(result => {
              //   if(result.value) {
              //     let amountProducedDuringRun = result.value;
              //     let amountProduced = this.getProducedAmountOfJobId(jobRunnning.id);
              //     amountProduced += result.value;
              //
              //     if(amountProduced > activeJob.amount) {
              //       this.swalAmountProducedWarning().then(result => {
              //         if(result.value) {
              //           resolve({
              //             activeJob: activeJob,
              //             amountProduced: amountProduced,
              //             amountProducedDuringRun: amountProducedDuringRun,
              //             status: 'finished',
              //             date: new Date()
              //           });
              //         }
              //       });
              //     } else {
              //       resolve({
              //         activeJob: activeJob,
              //         amountProduced: amountProduced,
              //         amountProducedDuringRun: amountProducedDuringRun,
              //         status: 'stopped',
              //         date: new Date()
              //       });
              //     }
              //   }
              // });
              // }
            }
          });
        });
      },
      /**
       * @vuese
       * Stops the selected workflow
       * @arg `selecftedJob` the job that is clicked
       * @arg `workflowState` the state of the selected job with the current workflow
       * */
      stopRunningWorkflow(selectedJob, workflowState) {
        let jobRunning = this.getRunningJob;

        // this.swalAmountProduced(selectedOrder).then(result => {
        this.swalJobIsDoneCheck(selectedJob.uid, selectedJob).then(async res => {
          let jobStatus = '';
          if(res.dismiss == 'backdrop') {
            return;
          }
          if(res.value) {
            jobStatus = 'finished';
          }
          if(selectedJob.id === jobRunning.id) {
            // this.setUserOrderData(null);
            this.getOrderWorkflowProduct = null;
          }
          this.setJobStopped(selectedJob, jobStatus, new Date(), workflowState.runningProductionRunOfWorkflow.id).then((res) => {
            if(res) {
              this.swalToastSuccess(this.$t('swal.toast.jobStopped') + ' ' + selectedJob.uid);
            }
          });
        });

      },
      /**
       * @vuese
       * Checks if a job can be started
       * And handles the stopping of the already running workflow.
       * @arg `selectedJob` the job that is clicked
       * @arg `jobWorkflow` the selected workflow
       */
      checkIfJobCanBeStarted(selectedJob, jobWorkflow) {
        return new Promise((possible, notPossible) => {

          // Ok orderline isn't finished, the orderline isn't running either, so let's try to run it.
          // Now we check if there is already an orderline running within the selected workflow
          let jobs = this.getJobs;
          let productionRunsOfWorkflow = this.getProductionRunsOfWorkflow(jobWorkflow);
          let runningProductionRunsOfWorkflow = productionRunsOfWorkflow.filter(productionRun => productionRun.productionEnd == undefined);
          jobs.filter(job => job.workflowId == jobWorkflow && job.status == 'running');
          if(runningProductionRunsOfWorkflow.length > 0) {
            // There is already an orderline running. Let's check if a second orderline is allowed within this workflow.
            let multiJobPossible = this.getWorkflowMultiJobPossible(jobWorkflow);
            if(multiJobPossible) {
              // Multiple orderlines allowed: let's start this orderline.
              possible();
            } else {
              // If only 1 orderline is running we can close it and start the new one.
              // It multiple running, which would only occur when the multi-orderline setting had been changed while multiple orderlines still running
              // then the user have to stop them manually.
              if(runningProductionRunsOfWorkflow.length == 1) {

                this.showStopOtherJobFirstModal(runningProductionRunsOfWorkflow[0], selectedJob, runningProductionRunsOfWorkflow[0].product).then((result) => {
                      // this.setJobStopped(result.activeJob, result.amountProduced, result.amountProducedDuringRun, result.status, result.date, runningProductionRunsOfWorkflow[0].id);
                      possible();
                    }
                );
              } else {
                notPossible();
              }
            }
          } else {
            // There are no running orderlines within the selected workflow.
            // So let's start this orderline.
            possible();
          }
        });
      },

      /**
       * @vuese
       * Starts or stops a selected job, based on the preferences of the selected workflow and the current state of the job
       * @arg `selectedJob` the job that is clicked
       */
      startStopWorkflow(selectedJob) {
        let jobWorkflow = this.getSelectedWorkflow;
        // If a Workflow line is selected else show warning
        if(jobWorkflow) {
          let workflowState = selectedJob.workflowStates.find(workflow => workflow.id == jobWorkflow);
          // Let's check if the selected job can be started
          if(workflowState && workflowState.status == 'running') {
            this.stopRunningWorkflow(selectedJob, workflowState);
          } else if(workflowState && workflowState.status == 'finished') {
            // The job is already finished: this should not be possible...
            // So the data is corrupt.
            alert('Error: Status of job is already finished...');
          } else {
            this.checkIfJobCanBeStarted(selectedJob, jobWorkflow).then(
                () => {
                  // Can start
                  this.setJobRun(selectedJob, jobWorkflow);
                },
                () => {
                  // Cannot start swalMultipleJobsNotPossible
                  this.swalMultipleJobsNotPossible();
                });
          }
        }
        // There is no Workflow selected
        else {
          this.swalChooseWorkflow(this.getWorkflowsIdName).then(() => {
            // After a workflow is selected; we start the job again.
            // We just call the function again to make sure all checks are executed again before starting

            let selectedJob = this.getSelectedWorkflow;

            // If a Workflow line is selected else show warning
            if(selectedJob) {
              let workflowState = selectedJob.workflowStates.find(workflow => workflow.id == selectedJob);
              if(workflowState.status == 'running') {
                this.$swal({
                  title: this.$t('jobs.startStop.productAlreadyRunning.title'),
                  text: this.$t('jobs.startStop.productAlreadyRunning.text'),
                  icon: 'warning'
                });
              } else {
                this.startStopWorkflow(selectedJob);
              }
            }
          });
        }
      }

    },
    watch: {
      '$route.params.id':{
        handler:async function(newV,oldV){
          console.log(newV,oldV)
          var self = this
          if(newV && oldV && newV !== oldV){
            self.initialized = false
            let where;
            // if(!this.getJob(this.$route.params.id)) {
            await this.$store.dispatch('jobs/fetchById', this.$route.params.id).then(res => {
              where = [
                ['companyId', '==', this.getClaims.companyId],
                ['uid', '==', res.uid]
              ];
            });


            await this.$store.dispatch('jobs/closeDBChannel', {clearModule: true}).catch(e => {
              console.error(e);
            });

            await this.$store.dispatch('jobs/openDBChannel', {where}).catch(e => {
              console.error(e);
            });
            this.initialized = true;
            // }
          }
        }
      }
    },

    // async beforeRouteLeave(to, from, next) {
    //   await this.$store.dispatch('jobs/closeDBChannel', {clearModule: true}).catch(e => {
    //     console.error(e);
    //   });
    //   next();
    // },
    async created() {
      const self = this;
      self.initialized = false
      let where;
      if(!this.getJob(this.$route.params.id)) {
        await this.$store.dispatch('jobs/fetchById', this.$route.params.id).then(res => {
          where = [
            ['companyId', '==', this.getClaims.companyId],
            ['uid', '==', res.uid]
          ];
        });


        await this.$store.dispatch('jobs/closeDBChannel', {clearModule: true}).catch(e => {
          console.error(e);
        });

        await this.$store.dispatch('jobs/openDBChannel', {where}).catch(e => {
          console.error(e);
        });

      }
      this.initialized = true;
      setInterval(() => {
        self.time = moment();
      }, 1000);
      this.tableInitOptions.order = [[1, 'desc']];
    }
  };
</script>

<style scoped lang="scss">
.btn-secondary {
  color: #fff;
  background-color: #0087ab;
  border-color: #0087ab;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background-color: darken(#0087ab, 10%);
    border-color: darken(#0087ab, 12%);
  }

  &:focus,
  &.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 135, 171, 0.5);
  }
}

::v-deep .get-data {
  font-size: 15px !important;
  text-transform: uppercase;
  i {
    margin-right: 15px;
  }
}
</style>

